export default class IdIsRequired extends Error {
}
